export const SHOW_PROJECT_MODAL = 'SHOW_PROJECT_MODAL';
export const SHOW_PROJECT_INVITE_MODAL = 'SHOW_PROJECT_INVITE_MODAL';

export const UPDATE_PROJECT_SUCCESS = 'UPDATE_PROJECT_SUCCESS';
export const UPDATE_PROJECT_FAILURE = 'UPDATE_PROJECT_FAILURE';

export const STORE_PROJECT_SUCCESS = 'STORE_PROJECT_SUCCESS';
export const STORE_PROJECT_FAILURE = 'STORE_PROJECT_FAILURE';

export const DESTROY_PROJECT_SUCCESS = 'DESTROY_PROJECT_SUCCESS';
export const DESTROY_PROJECT_FAILURE = 'DESTROY_PROJECT_FAILURE';

export const SET_PROJECT = 'SET_PROJECT';
export const SUBSCRIBE_CREATE_PROJECT = 'SUBSCRIBE_CREATE_PROJECT';

export const FETCH_PROJECTS_SUCCESS = 'FETCH_PROJECTS_SUCCESS';
export const FETCH_PROJECTS_FAILURE = 'FETCH_PROJECTS_FAILURE';

export const INVITE_USERS_SUCCESS = 'INVITE_USERS_SUCCESS';
export const INVITE_USERS_FAILURE = 'INVITE_USERS_FAILURE';

export const DELETE_USERS_SUCCESS = 'DELETE_USERS_SUCCESS';
export const DELETE_USERS_FAILURE = 'DELETE_USERS_FAILURE';
